import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { themeNames } from '@upgrade/themes';
var ENV_APP_PREFIXES = ['REACT_APP_', 'GATSBY_', 'STORYBOOK_'];
var UNIVERSAL_CREDIT_HOSTNAME_ENV_KEY = 'UNIVERSAL_CREDIT_HOSTNAME';
export var getCurrentThemeName = function getCurrentThemeName(env) {
  if (global.location && global.location.hostname && ENV_APP_PREFIXES.some(function (appEnvPrefix) {
    return env["".concat(appEnvPrefix).concat(UNIVERSAL_CREDIT_HOSTNAME_ENV_KEY)] === global.location.hostname;
  })) {
    return themeNames.UNIVERSAL_CREDIT_THEME_NAME;
  }
  return themeNames.UPGRADE_THEME_NAME;
};
export var isUniversalCreditHostname = function isUniversalCreditHostname(env) {
  return getCurrentThemeName(env) === themeNames.UNIVERSAL_CREDIT_THEME_NAME;
};
export var getThemedEnv = function getThemedEnv(env) {
  if (!global.location) {
    return env;
  }
  var themedEnv = _objectSpread({}, env);
  var themeName = getCurrentThemeName(env);
  if (themeName) {
    Object.keys(themedEnv).forEach(function (envKey) {
      ENV_APP_PREFIXES.forEach(function (envAppPrefix) {
        var _envKey$split = envKey.split(envAppPrefix),
          _envKey$split2 = _slicedToArray(_envKey$split, 2),
          envKeyWithoutAppPrefix = _envKey$split2[1];
        if (envKeyWithoutAppPrefix) {
          var themedEnvKey = "".concat(envAppPrefix).concat(themeName.toUpperCase(), "_").concat(envKeyWithoutAppPrefix);
          if (env[themedEnvKey]) {
            themedEnv[envKey] = themedEnv[themedEnvKey];
          }
        }
      });
    });
  }
  return themedEnv;
};